import React, { useState } from 'react'
import { Box, Typography, Collapse, Button } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRightOutlined'

const CollapsibleSection: React.FC<{ title: React.ReactNode; children: React.ReactNode }> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Box width="100%">
      <Button
        onClick={() => setIsOpen(!isOpen)}
        // size="small"
        startIcon={isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        sx={{
          height: 'auto',
          textTransform: 'none',
          p: '2px 0',
          justifyContent: 'flex-start',
          width: '100%',
          mt: '0.2rem',
        }}
      >
        <Typography
          variant="text2"
          sx={{
            textAlign: 'left',
          }}
          title={typeof title === 'string' ? title : undefined} // Show full title on hover
        >
          {title}
        </Typography>
      </Button>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box sx={{ pl: '26px', my: 1 }} display="flex" flexDirection="column">
          {children}
        </Box>
      </Collapse>
    </Box>
  )
}

export default CollapsibleSection
